// HistoryContext.tsx
import { createContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

type HistoryContextType = {
  history: string[];
  setHistory: React.Dispatch<React.SetStateAction<string[]>>;
};

export const HistoryContext = createContext<HistoryContextType>({
  history: [],
  setHistory: () => {},
});

export const HistoryProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    setHistory(prev => [...prev, location.pathname]);
  }, [location]);

  return (
    <HistoryContext.Provider value={{history, setHistory}}>
      {children}
    </HistoryContext.Provider>
  );
};
